var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.906.593 1.196 2.924a.844.844 0 0 0 1.225.399l2.687-1.664c.726-.449 1.632.209 1.428 1.038l-.75 3.07a.844.844 0 0 0 .756 1.042l3.151.233c.852.064 1.198 1.128.546 1.68l-2.412 2.04a.844.844 0 0 0 0 1.289l2.412 2.041c.652.552.306 1.616-.546 1.68l-3.15.233a.844.844 0 0 0-.758 1.043l.752 3.069c.203.83-.703 1.487-1.429 1.038l-2.687-1.664a.844.844 0 0 0-1.225.399l-1.196 2.924c-.323.79-1.442.79-1.766 0l-1.196-2.924a.844.844 0 0 0-1.225-.399l-2.686 1.664c-.726.449-1.632-.209-1.429-1.038l.752-3.07a.844.844 0 0 0-.758-1.042l-3.15-.233C.595 16.3.25 15.237.901 14.685l2.411-2.04a.844.844 0 0 0 0-1.289L.902 9.315c-.652-.552-.306-1.616.545-1.68l3.151-.233a.844.844 0 0 0 .757-1.043L4.604 3.29c-.203-.83.703-1.487 1.429-1.038l2.686 1.664a.844.844 0 0 0 1.225-.399L11.14.593c.324-.79 1.443-.79 1.766 0zM18.398 12a6.382 6.382 0 0 0-6.375-6.375A6.382 6.382 0 0 0 5.648 12a6.382 6.382 0 0 0 6.375 6.375A6.382 6.382 0 0 0 18.398 12zm-1.5 0a4.88 4.88 0 0 1-4.875 4.875A4.88 4.88 0 0 1 7.148 12a4.88 4.88 0 0 1 4.875-4.875A4.88 4.88 0 0 1 16.898 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.7e81bd0fa9414c1847368880ed7f9d0f.svg";
export { ForwardRef as ReactComponent };